import React, { useState } from "react";

import "./rangeSlider.css";
import RangeSliderCircle from "./rangeSliderCircle";
import RangeSliderCircleRealValue from "./rangeSliderCircleRealValue";
import RangeSliderWrapper from "./rangeSliderWrapper";

interface SliderProps {
    default: number;
    min: number;
    max: number;
    step: number;
    onUpdate: (value: number) => void;
    title: string;
    checkTitle?: (value: number) => string | undefined;
}

export default function RangeSlider(props: SliderProps) {

    const [value, setValue] = useState(props.default);

    return <RangeSliderWrapper checkTitle={props.checkTitle} title={props.title} values={{
        value: value
    }}>
        <RangeSliderCircleRealValue default={props.default} min={props.min} max={props.max} step={props.step} onUpdate={(newValue: number) => {
                if(newValue != value) {
                    setValue(newValue);
                    props.onUpdate(newValue);
                }
            }}/>
    </RangeSliderWrapper>;

}